export const accounts = [
  { id: 'acc_g1', provider: 'google', name: 'Acme Ecommerce — Google Ads', status: 'connected' },
  { id: 'acc_m1', provider: 'meta',   name: 'Acme Ecommerce — Meta Ads',   status: 'connected' },
  { id: 'acc_t1', provider: 'tiktok', name: 'Acme Ecommerce — TikTok Ads', status: 'connected' },
];
